import React, { useState } from 'react';
import "./UniversityOfAlaskaAward.scss";
import CTAButton from '../CTAButton/CTAButton';
import Field from '../../Components/Field/Field';
import { CreateOptions } from '../../Utility/SelectListLoader';
import { toast } from 'react-toastify';
import KaleidoscopeAPI from '../../Core/KaleidoscopeAPI';
import FlashMessage from '../FlashMessage/Message'
import { formatCurrency, formatLabelANDValue } from '../../Utility/HelperFunctions';
import { handleKeyDown } from '../../Utility/ApplicationFormUtility';
import Close from '../SVG/Close';
import { MAIN_CONFIG } from '../../../config/main';

export default function UniversityOfAlaskaAward({ application, handleClose = () => { }, closeAndRefreshTable = () => { }, accountData, data = () => { } }) {
  const API = new KaleidoscopeAPI({});
  const statusList = ['Committee Recommendation', 'Alternate']
  const awardYearList = ['2020-2021', '2021-2022', '2022-2023', '2023-2024', '2024-2025', '2025-2026']
  const scholarshipTermOptions = [
    'Fall 2022',
    'Fall 2023',
    'Fall 2024',
    'Fall 2025',
    'Spring 2022',
    'Spring 2023',
    'Spring 2024',
    'Spring 2025',
    'Spring 2026',
    'Summer 2022',
    'Summer 2023',
    'Summer 2024',
    'Summer 2025',
    'Summer 2022 & Fall 2022',
    'Spring 2023 & Summer 2023',
    'Academic Year 2022-2023',
    'Academic Year 2023-2024',
    'Academic Year 2024-2025',
    'Academic Year 2025-2026'
  ]
  const CampusForOrgCode = ['UAS', 'UAF', 'UAA']

  const removeCommaFromAmount = (amount) => {
    return (amount && amount.toString().includes(",")) ? amount.split(',').join('') : amount;
  };

  const formatDataForAPI = (awardData) => {
    for (const key in awardData) {
      if (awardData[key] && awardData[key].label) {
        awardData[key] = awardData[key].value;
      }
    }
    return {
      application: { status__c: awardData.status__c || '' },
      alaska_award: {
        award_year__c: awardData.award_year__c || '',
        award_amount__c: awardData.award_amount__c || '',
        status__c: awardData.status__c === 'Alternate' ? 'Alternate #1' : awardData.status__c || '',
        scholarship_term__c: awardData.scholarship_term__c || '',
        description__c: awardData.description__c || '',
        campus_for_org_code__c : awardData?.campus_for_org_code__c || ''

      }
    };
  };

  const initialStateAlaskaAward = {
    award_year__c: formatLabelANDValue(data?.alaska_award?.award_year__c || ''),
    award_amount__c: formatCurrency(data?.alaska_award?.award_amount__c || ''),
    status__c: formatLabelANDValue(data?.alaska_award?.status__c === 'Alternate #1' ? 'Alternate' : data?.alaska_award?.status__c || ''),
    scholarship_term__c: formatLabelANDValue(data?.alaska_award?.scholarship_term__c || ''),
    description__c: data?.alaska_award?.description__c || '',
    campus_for_org_code__c : formatLabelANDValue(data?.alaska_award?.campus_for_org_code__c || '')
  };

  const [alaskaAwardData, setAlaskaAwardData] = useState(initialStateAlaskaAward);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { status__c, award_year__c, award_amount__c, scholarship_term__c, description__c, campus_for_org_code__c } = alaskaAwardData;
    const awardData = { status__c, award_year__c, award_amount__c: removeCommaFromAmount(award_amount__c), scholarship_term__c, description__c, campus_for_org_code__c };
    const formattedDataForAPI = formatDataForAPI(awardData);

    if ((!campus_for_org_code__c || Object.keys(campus_for_org_code__c).length === 0)) {
      toast.error(<FlashMessage type='error' message="Please select campus" />);
      return;
    }

    const response = await API.CreteAlaskaAward({
      token: accountData.token,
      accountId: accountData.currentAccount.sfid,
      scholarshipId: application.scholarship__c,
      applicationId: application.sfid,
      alaskaAwardDetails: formattedDataForAPI
    });

    if (response.success) {
      toast.success(<FlashMessage message={response.message || 'Disbursement updated'} />);
      closeAndRefreshTable();
    } else {
      toast.error(<FlashMessage type="error" message={response.error || response.message} />);
    }
  };

  const onChange = (name, value) => {
    const updatedApplications = { ...alaskaAwardData, [name]: value };
    setAlaskaAwardData(updatedApplications);
  };

  const getSelectValue = (value) => {
    return value.value ? value : '';
  };

  return (
    <div className="create-award-page">
      <div className="create-award-page__header">
        <div>
          <h1 className='H1DesktopGreen create-award-title'>{ `${application.is_alaska_award_created ? 'Update Award Record' : 'Create Award Record'}`}</h1>
        </div>
        <div>
         <button onKeyDown={(e)=>handleKeyDown(e,()=>handleClose())} aria-label='Close Modal' className="event-head H6DesktopGrey close-btn" onClick={handleClose}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1}/></button>
        </div>
      </div>
      <div className="create-award-page__content">
        <Field
          className='field-group__field-full'
          type='select'
          label='Application Status'
          placeholder='Application Status'
          options={CreateOptions(statusList)}
          value={getSelectValue(alaskaAwardData?.status__c)}
          handleChange={(val) => onChange('status__c', val)}
        />
        <Field
          className='field-group__field-full'
          type='money'
          label='Award Amount'
          placeholder='Award Amount'
          value={alaskaAwardData?.award_amount__c}
          handleChange={(val) => onChange('award_amount__c', val)} />
        <Field
          className='field-group__field-full'
          type='select'
          label='Award Year'
          placeholder='Award Year'
          options={CreateOptions(awardYearList)}
          value={getSelectValue(alaskaAwardData?.award_year__c)}
          handleChange={(val) => onChange('award_year__c', val)}
        />
        <Field
          className='field-group__field-full'
          type='select'
          label='Scholarship Term'
          placeholder='Scholarship Term'
          options={CreateOptions(scholarshipTermOptions)}
          value={getSelectValue(alaskaAwardData?.scholarship_term__c)}
          handleChange={(val) => onChange('scholarship_term__c', val)}
        />
         <Field
          className='field-group__field-full'
          type='select'
          label='Campus'
          placeholder='Campus'
          options={CreateOptions(CampusForOrgCode)}
          value={getSelectValue(alaskaAwardData?.campus_for_org_code__c)}
          handleChange={(val) => onChange('campus_for_org_code__c', val)}
          requiredAsterisk={true}
        />
        <Field
          className='field-group__field-full'
          type='textarea'
          label='Description'
          value={alaskaAwardData?.description__c}
          placeholder='Description'
          handleChange={(val) => onChange('description__c', val)}
        />
      </div>
      <div className="create-award-page__footer">
        <div className="footer-button-section">
          <CTAButton id='award-page__cta__cancel' type='inverse' outline onClick={handleClose}>
            Cancel
          </CTAButton>
          <CTAButton id='award-page__cta' type='tertiary' onClick={handleSubmit}>
            Submit
          </CTAButton>
        </div>

      </div>
    </div>
  )
}